import { Component, Injector, Optional } from '@angular/core';

import { MerkService } from 'src/app/core/service/merk.service';
import { Merk } from 'src/app/core/dto/merk';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';

@Component({
    selector: 'c-i-j-borculo-merk-collection',
    templateUrl: './merk-collection.component.html'/*,
    styleUrls: ['./merk-collection.component.css'] */
})
export class MerkCollectionComponent extends PagedCollectionComponent<Merk> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Merk>([
		{ colDef: 'omschrijving', prop: x => x.omschrijving, searchable: SearchableType.String }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: MerkService, @Optional() protected filter: Filter<Merk>, injector: Injector) {
        super('/merk/merk', injector, Merk);

        this.filter.onGetChipLabel(x => x.omschrijving, () => 'Omschrijving');
    }
}